"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Instagram, Linkedin, Youtube } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-6">
        {[...Array(6)].map((_, i) => <div key={i} className="h-4 w-16 bg-muted/30 animate-pulse rounded" data-index={i} />)}
      </div>;
  }
  return <nav className="flex flex-wrap justify-center gap-6">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-sm text-white transition-colors duration-[var(--duration-medium)] relative group" data-index={i}>
          {item.label}
          <span className="absolute bottom-0 left-0 w-0 h-px bg-accent group-hover:w-full transition-all duration-[var(--duration-medium)]" />
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref: copyrightRef,
    isVisible: copyrightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: socialsRef,
    isVisible: socialsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: navRef,
    isVisible: navVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Instagram,
    href: "https://www.instagram.com/raamonnewman",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://www.linkedin.com/in/raamonnewman/",
    label: "LinkedIn"
  }, {
    icon: Youtube,
    href: "https://www.youtube.com/newmavericks",
    label: "YouTube"
  }];
  return <footer id="footer" className="w-full py-12 px-4 !bg-[hsl(218,11%,65%)]">
      <div className="max-w-7xl mx-auto space-y-8">
        <div ref={socialsRef} className={`flex justify-center gap-4 transition-all duration-[var(--duration-fast)] delay-100 ${socialsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {socialLinks.map((social, i) => {
          const Icon = social.icon;
          return <Link key={social.label} to={social.href} newTab className="text-white transition-all duration-[var(--duration-medium)] hover:scale-105" aria-label={social.label} data-index={i}>
                <Icon className="size-10" />
              </Link>;
        })}
        </div>

        <div ref={navRef} className={`transition-all duration-[var(--duration-fast)] delay-200 ${navVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <MenuProvider menu_id="4">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        <div ref={copyrightRef} className={`text-center transition-all duration-[var(--duration-fast)] ${copyrightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="text-sm text-white">© 2026&nbsp;Raam Global Consulting LLC &amp; New Mavericks. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}